export default "__VITE_ASSET__Dtpm7Nu6__"